import * as React from "react";
const CheckXBold = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "currentColor", width: size || "16", height: size || "16", ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M2.58594 8.13691L6.78515 12.3361L13.4144 5.70691L11.2932 3.58569L6.78515 8.09369L4.70715 6.01569L2.58594 8.13691Z", clipRule: "evenodd" }));
CheckXBold.displayName = "CheckXBold";
var CheckXBold_default = CheckXBold;
export {
  CheckXBold_default as default
};
